import { $currentUserCache } from 'src/services/user/current-user';

/** 获取当前操作的用户updated信息 */
export const getUpdatedAtAndUpdatedBy = () => {
  return {
    updatedBy: $currentUserCache.uuid,
    updatedAt: Date.now(),
  };
};
